import {Padron} from './padrones-core.model';
import {DetailField} from '../../../shared/models';

export const PADRONESCOREDETAIL_DEFAULT_FIELDS: DetailField[] = [
  { name: 'departamentoNombre', label: 'Departamento' },
  { name: 'padronId', label: 'Nro' },
  { name: 'padronArea', label: 'Área (ha)' },
];

export interface PadronesCoreDetailParams {
  padron: Padron;
  fields?: DetailField[];
}
